import { createEntityAdapter } from "@reduxjs/toolkit";
import type { Activity } from "@repo/app-types/entities/activity";
import type { RootState } from "../../app/store.js";

export const activitiesAdapter = createEntityAdapter<Activity>();

export const selectActivitiesDictionary = activitiesAdapter.getSelectors(
  (state: RootState) => state.activities,
).selectEntities;

export const selectAllActivities = activitiesAdapter.getSelectors().selectAll;
